var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#F9B609"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 23L20.5 15",
    stroke: "#0F1111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 34.8014V21.1986C44.4994 20.6022 44.3348 20.0165 44.0227 19.5002C43.7107 18.9839 43.2622 18.5552 42.7222 18.257L30.2778 11.4556C29.7373 11.1571 29.1241 11 28.5 11C27.8759 11 27.2627 11.1571 26.7222 11.4556L14.2778 18.257C13.7378 18.5552 13.2893 18.9839 12.9773 19.5002C12.6652 20.0165 12.5006 20.6022 12.5 21.1986V34.8014C12.5006 35.3977 12.6652 35.9835 12.9773 36.4998C13.2893 37.0161 13.7378 37.4448 14.2778 37.743L26.7222 44.5444C27.2627 44.8429 27.8759 45 28.5 45C29.1241 45 29.7373 44.8429 30.2778 44.5444L42.7222 37.743C43.2622 37.4448 43.7107 37.0161 44.0227 36.4998C44.3348 35.9835 44.4994 35.3977 44.5 34.8014Z",
    stroke: "#0F1111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20L28.3044 28L43.5 20",
    stroke: "#0F1111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 44L28.5 28",
    stroke: "#0F1111",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders-icon.ea54c7cf38b727939ed65fcf64c4215b.svg";
export { ForwardRef as ReactComponent };